export default __webpack_public_path__ + "static/media/0x5b4cf2c120a9702225814e18543ee658c5f8631e.27b7e39c.webp";